/* TuinDepot — levervoorkeur-kalender voor alle leverbare producten behalve Bloemen en planten
   (snippets/losgestort-planning.liquid). Regels: vroegste dag = derde werkdag na besteldag
   (de eerste twee volgende werkdagen zijn nooit selecteerbaar); enkel ma-vr; woensdag alleen voormiddag; minstens 5 dagen
   (afrekenen wordt anders tegengehouden) en voor losgestort ook minstens 3 m3; bereik 6 weken. Per dag: tik op het cijfer = hele dag, op vm/nm = dat dagdeel. Keuzes gaan als cart attributes mee (Leverdata + Leverdata-code).
   Het blok is een <details>: dichtgeklapt toont de kopregel een teller (x/5 gekozen); de checkout-guard klapt het blok open bij een melding.
   Winkelwagenpagina: na elke wijziging haalt verify() de sectie opnieuw op om blok en plantenmelding bij te werken. */
(function () {
  'use strict';

  var MON_LONG = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
  var MON_SHORT = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
  var DAY_SHORT = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
  var DAY_LONG = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var PERIOD_TEXT = { VM: 'voormiddag', NM: 'namiddag', VN: 'voor- of namiddag' };
  var PERIOD_LABEL = { VM: 'Voormiddag', NM: 'Namiddag', VN: 'Beide' };
  var MIN_DAYS = 5;
  var MIN_M3 = 3;
  var RANGE_DAYS = 42;
  var WEEKS_PER_PAGE = 3;
  var DEFAULT_TEXT = 'Geen dagen gekozen';
  var EMPTY = { Leverdata: null, 'Leverdata-code': null, Leverperiode: null, Leverdagen: null, Dagdeel: null, Losplek: null };
  var pending = null, pushTimer = null, verifyTimer = null;

  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function fromIso(s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2], 12); }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function shortLabel(d) { return DAY_SHORT[d.getDay()] + ' ' + d.getDate() + ' ' + MON_SHORT[d.getMonth()]; }
  function longLabel(d) { return DAY_LONG[d.getDay()] + ' ' + d.getDate() + ' ' + MON_LONG[d.getMonth()]; }

  function earliest() {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    var wd = 0;
    while (wd < 3) {
      d = addDays(d, 1);
      if (d.getDay() >= 1 && d.getDay() <= 5) wd++;
    }
    return d;
  }
  function mondayOf(d) { return addDays(d, -((d.getDay() + 6) % 7)); }

  function push(attrs) {
    pending = Object.assign(pending || {}, attrs);
    clearTimeout(pushTimer);
    pushTimer = setTimeout(function () {
      var body = JSON.stringify({ attributes: pending });
      pending = null;
      fetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body
      }).catch(function () {});
    }, 400);
  }

  /* ---- state ---- */
  function newState(block) {
    var e = earliest();
    var st = { start: e, end: addDays(e, RANGE_DAYS - 1), page: 0, sel: [] };
    st.week0 = mondayOf(e);
    st.pages = Math.ceil((Math.round((st.end - st.week0) / 864e5) + 1) / 7 / WEEKS_PER_PAGE);
    st.sel = parseCode(block.getAttribute('data-lg-code') || '', st);
    return st;
  }

  function selectable(d, st) {
    var wd = d.getDay();
    return wd >= 1 && wd <= 5 && d >= st.start && d <= st.end;
  }

  function parseCode(code, st) {
    var out = [];
    if (!code) return out;
    code.split(',').forEach(function (part) {
      var p = part.split(':');
      if (p.length !== 2 || !/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(p[0]) || !PERIOD_TEXT[p[1]]) return;
      var d = fromIso(p[0]);
      if (!selectable(d, st)) return;
      var period = d.getDay() === 3 ? 'VM' : p[1];
      if (!out.some(function (s) { return s.iso === p[0]; })) out.push({ iso: p[0], period: period });
    });
    out.sort(function (a, b) { return a.iso < b.iso ? -1 : 1; });
    return out;
  }

  function codeOf(st) { return st.sel.map(function (s) { return s.iso + ':' + s.period; }).join(','); }
  function humanOf(st) {
    if (!st.sel.length) return DEFAULT_TEXT;
    return st.sel.map(function (s) { return shortLabel(fromIso(s.iso)) + ' (' + PERIOD_TEXT[s.period] + ')'; }).join(', ');
  }

  /* ---- rendering ---- */
  function renderCalendar(block, st) {
    var cal = block.querySelector('[data-lg-cal]');
    if (!cal) return;
    var pageStart = addDays(st.week0, st.page * WEEKS_PER_PAGE * 7);
    var html = '<div class="lg-cal__nav">';
    html += '<button type="button" data-lg-nav="-1" aria-label="Vorige weken"' + (st.page === 0 ? ' disabled' : '') + '>&lsaquo;</button>';
    var first = null, last = null;
    for (var i = 0; i < WEEKS_PER_PAGE * 7; i++) {
      var dd = addDays(pageStart, i);
      if (selectable(dd, st)) { if (!first) first = dd; last = dd; }
    }
    var range = first ? (first.getDate() + ' ' + MON_SHORT[first.getMonth()] + ' – ' + last.getDate() + ' ' + MON_SHORT[last.getMonth()]) : '';
    html += '<span class="lg-cal__range">' + range + '</span>';
    html += '<button type="button" data-lg-nav="1" aria-label="Volgende weken"' + (st.page >= st.pages - 1 ? ' disabled' : '') + '>&rsaquo;</button>';
    html += '</div><div class="lg-cal__grid" role="grid">';
    ['ma', 'di', 'wo', 'do', 'vr'].forEach(function (w) { html += '<div class="lg-cal__wd">' + w + '</div>'; });
    for (var w = 0; w < WEEKS_PER_PAGE; w++) {
      for (var wd = 0; wd < 5; wd++) {
        var d = addDays(pageStart, w * 7 + wd);
        var id = iso(d);
        var mLabel = (d.getDate() === 1 || (w === 0 && wd === 0)) ? '<span class="lg-day__m">' + MON_SHORT[d.getMonth()] + '</span>' : '';
        if (!selectable(d, st)) {
          html += '<div class="lg-day is-off">' + mLabel + '<span class="lg-day__n">' + d.getDate() + '</span></div>';
          continue;
        }
        var sel = null;
        st.sel.forEach(function (s) { if (s.iso === id) sel = s; });
        var vm = !!sel && (sel.period === 'VM' || sel.period === 'VN');
        var nm = !!sel && (sel.period === 'NM' || sel.period === 'VN');
        var wo = d.getDay() === 3;
        var ll = longLabel(d);
        html += '<div class="lg-day' + (sel ? ' is-sel' : '') + (wo ? ' is-wo' : '') + '" data-lg-iso="' + id + '">' + mLabel;
        html += '<button type="button" class="lg-day__n" data-lg-full aria-pressed="' + (sel ? 'true' : 'false') + '" aria-label="' + ll + ', hele dag">' + d.getDate() + '</button>';
        html += '<span class="lg-day__halves">';
        html += '<button type="button" class="lg-half' + (vm ? ' is-on' : '') + '" data-lg-half="VM" aria-pressed="' + (vm ? 'true' : 'false') + '" aria-label="' + ll + ', voormiddag">vm</button>';
        if (wo) html += '<span class="lg-half is-na" aria-hidden="true">nm</span>';
        else html += '<button type="button" class="lg-half' + (nm ? ' is-on' : '') + '" data-lg-half="NM" aria-pressed="' + (nm ? 'true' : 'false') + '" aria-label="' + ll + ', namiddag">nm</button>';
        html += '</span></div>';
      }
    }
    html += '</div>';
    cal.innerHTML = html;
  }

  function renderCount(block, st, warn) {
    var c = block.querySelector('[data-lg-count]');
    if (!c) return;
    var n = st.sel.length;
    c.textContent = n + '/' + MIN_DAYS + ' gekozen';
    c.classList.toggle('is-ok', n >= MIN_DAYS);
    c.classList.toggle('is-warn', !!warn && n < MIN_DAYS);
  }

  function sync(block, st, doPush) {
    var h = block.querySelector('[data-lg-field="Leverdata"]');
    var c = block.querySelector('[data-lg-field="LeverdataCode"]');
    var human = humanOf(st), code = codeOf(st);
    if (h) h.value = human;
    if (c) c.value = code;
    block.setAttribute('data-lg-code', code);
    renderCount(block, st, false);
    if (doPush) push({ Leverdata: human, 'Leverdata-code': code, Leverperiode: null, Leverdagen: null, Dagdeel: null });
  }

  function setHint(block, text, warn, ms) {
    var hint = block.querySelector('[data-lg-hint]');
    if (!hint) return;
    if (!hint.getAttribute('data-lg-default')) hint.setAttribute('data-lg-default', hint.textContent);
    hint.textContent = text || hint.getAttribute('data-lg-default');
    hint.classList.toggle('is-warn', !!warn);
    clearTimeout(hint._t);
    if (text) hint._t = setTimeout(function () { hint.textContent = hint.getAttribute('data-lg-default'); hint.classList.remove('is-warn'); }, ms || 2500);
  }

  function init(block) {
    if (block.hasAttribute('data-lg-init')) return;
    block.setAttribute('data-lg-init', '1');
    var st = newState(block);
    block._lg = st;
    var storedCode = block.getAttribute('data-lg-code') || '';
    var stored = block.getAttribute('data-lg-stored') === '1';
    renderCalendar(block, st);
    sync(block, st, !stored || storedCode !== codeOf(st));
  }

  function clear(el) {
    if (el.hasAttribute('data-lg-done')) return;
    el.setAttribute('data-lg-done', '1');
    push(EMPTY);
  }

  function scan() {
    document.querySelectorAll('[data-lg-planning]:not([data-lg-init])').forEach(init);
    document.querySelectorAll('[data-lg-clear]:not([data-lg-done])').forEach(clear);
  }

  /* ---- interaction (delegated, survives drawer re-renders) ---- */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var block = t.closest('[data-lg-planning]');
    if (!block || !block._lg) return;
    var st = block._lg;

    var nav = t.closest('[data-lg-nav]');
    if (nav) {
      st.page = Math.max(0, Math.min(st.pages - 1, st.page + parseInt(nav.getAttribute('data-lg-nav'), 10)));
      renderCalendar(block, st);
      return;
    }
    var cell = t.closest('[data-lg-iso]');
    if (!cell) return;
    var id = cell.getAttribute('data-lg-iso');
    var wo = fromIso(id).getDay() === 3;
    var half = t.closest('[data-lg-half]');
    var full = t.closest('[data-lg-full]');
    if (!half && !full) return;
    var idx = -1;
    st.sel.forEach(function (s, i) { if (s.iso === id) idx = i; });
    var cur = idx >= 0 ? st.sel[idx] : null;
    var next = null;
    if (full) {
      next = cur ? null : (wo ? 'VM' : 'VN');
    } else {
      var h = half.getAttribute('data-lg-half');
      if (wo && h === 'NM') return;
      if (!cur) next = h;
      else if (cur.period === h) next = null;
      else if (cur.period === 'VN') next = (h === 'VM' ? 'NM' : 'VM');
      else next = 'VN';
    }
    if (!next) { if (idx >= 0) st.sel.splice(idx, 1); }
    else if (cur) cur.period = next;
    else { st.sel.push({ iso: id, period: next }); st.sel.sort(function (a, b) { return a.iso < b.iso ? -1 : 1; }); }
    renderCalendar(block, st);
    sync(block, st, true);
  });

  /* Afrekenen tegenhouden zolang er minder dan MIN_DAYS dagen gekozen zijn. */
  function blockFor(el) {
    var formId = el.getAttribute('form') || (el.form && el.form.id) || '';
    var block = formId ? document.querySelector('[data-lg-planning][data-lg-form="' + formId + '"]') : null;
    if (!block) {
      var all = document.querySelectorAll('[data-lg-planning]');
      for (var i = 0; i < all.length; i++) { if (all[i].getClientRects().length) { block = all[i]; break; } }
    }
    return block && !block.hidden && block._lg && block.getClientRects().length ? block : null;
  }
  function guard(ev, el) {
    var block = blockFor(el);
    if (!block) return true;
    var qty = parseInt(block.getAttribute('data-lg-qty'), 10) || 0;
    var msg = null;
    if (qty > 0 && qty < MIN_M3) msg = 'Losgestort vanaf ' + MIN_M3 + 'm³ - kies bigbag voor kleine hoeveelheid.';
    else if (block._lg.sel.length < MIN_DAYS) msg = 'Kies minstens ' + MIN_DAYS + ' dagen om te leveren.';
    if (!msg) return true;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    if ('open' in block) block.open = true;
    renderCount(block, block._lg, true);
    setHint(block, msg, true, 6000);
    try { block.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
    return false;
  }
  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('[name="checkout"]');
    if (btn) guard(ev, btn);
  }, true);
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || (f.id !== 'cart' && f.id !== 'CartDrawer-Form')) return;
    var sub = ev.submitter;
    if (sub && sub.getAttribute('name') !== 'checkout') return;
    guard(ev, sub || f);
  }, true);

  /* Winkelwagenpagina: het blok wordt daar niet vanzelf opnieuw gerenderd. Na een wijziging halen we
     de sectie opnieuw op en werken blok (tonen/verbergen, m3-teller) en plantenmelding bij. Verschijnt
     het blok pas nu (eerste verzendbare product toegevoegd), dan herladen we de pagina één keer. */
  function verify() {
    clearTimeout(verifyTimer);
    verifyTimer = setTimeout(function () {
      var items = document.getElementById('main-cart-items');
      var sid = items && items.getAttribute('data-id');
      if (!sid) return;
      fetch(root() + 'cart?section_id=' + encodeURIComponent(sid), { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nb = doc.querySelector('[data-lg-planning]');
          var nn = doc.querySelector('[data-lg-notice]');
          var cur = document.querySelector('[data-lg-planning][data-lg-context="page"]');
          if (nb && !cur) {
            try {
              var last = parseInt(sessionStorage.getItem('lgReload') || '0', 10);
              if (Date.now() - last < 5000) return;
              sessionStorage.setItem('lgReload', String(Date.now()));
            } catch (e) {}
            location.reload();
            return;
          }
          if (!cur) return;
          var has = !!nb;
          cur.hidden = !has;
          cur.setAttribute('data-lg-qty', has ? (nb.getAttribute('data-lg-qty') || '0') : '0');
          cur.querySelectorAll('[form]').forEach(function (f) { f.disabled = !has; });
          var curN = document.querySelector('[data-lg-notice]');
          if (has && nn && !curN && cur.parentNode) cur.parentNode.insertBefore(document.importNode(nn, true), cur);
          else if ((!has || !nn) && curN) curN.remove();
          if (!has) push(EMPTY);
        })
        .catch(function () {});
    }, 400);
  }

  var observer = new MutationObserver(function (muts) {
    var cartChanged = false;
    for (var i = 0; i < muts.length; i++) {
      var target = muts[i].target;
      if (target && target.closest && target.closest('#main-cart-items')) { cartChanged = true; break; }
    }
    scan();
    if (cartChanged) verify();
  });

  function start() {
    scan();
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
